// extracted by mini-css-extract-plugin
export default {"msgM":"_9d3ca9eb2e"};